module.exports = __webpack_public_path__ + "img/add_user.be7566f4.svg";